/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions
     */
    AppLinkUrl: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions
     */
    AppId: string;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions {
    if (!('AppLinkUrl' in value) || value['AppLinkUrl'] === undefined) return false;
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'AppLinkUrl': json['AppLinkUrl'],
        'AppId': json['AppId'],
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppLinkUrl': value['AppLinkUrl'],
        'AppId': value['AppId'],
    };
}

